import { Injectable } from '@angular/core';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import { AppSetting } from '@lbmx/types';
import { Observable } from 'rxjs';
import {
  IAddOnboardingMemberRequest,
  IConfigCountry,
  IConfigProvince,
  IMemberProfileForm,
  ISupplierProfileForm
} from 'src/app/dtos/onboarding/onboarding.dto';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Injectable({
  providedIn: 'root',
})

export class OnboardingService {
  public appSettings: AppSetting = this.configPrv.AppSetting;
  constructor(
    private baseApiService: BaseAPIService,
    private configPrv: ConfigProvider
  ) {}

  public submitMember(request: IAddOnboardingMemberRequest): Observable<any> {
    this.baseApiService.set(
      this.appSettings.uriOnboarding.submitMember
    );
    return this.baseApiService.post(request).pipe();
  }

  public submitSupplier(request: ISupplierProfileForm): Observable<any> {
    this.baseApiService.set(
      this.appSettings.uriOnboarding.submitSupplier
    );
    return this.baseApiService.post(request).pipe();
  }

  public getCountries(): Observable<IConfigCountry[]> {
    this.baseApiService.set(
      this.appSettings.uriConfig.getCountries);
    return this.baseApiService.get<IConfigCountry[]>();
  }

  public getProvinces(): Observable<IConfigProvince[]> {
    this.baseApiService.set(
      this.appSettings.uriConfig.getProvinces);
    return this.baseApiService.get<IConfigProvince[]>();
  }
}
